import { render } from "./MainFooter.vue?vue&type=template&id=24b8bd6c"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/MainFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24b8bd6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24b8bd6c', __exports__)) {
    api.reload('24b8bd6c', __exports__)
  }
  
  module.hot.accept("./MainFooter.vue?vue&type=template&id=24b8bd6c", () => {
    api.rerender('24b8bd6c', render)
  })

}


export default __exports__